import Cookies from 'js-cookie';
import { ApolloLink, Observable } from '@apollo/client/core';

// Lazy-loads pusher-js only when a subscription is first triggered (~139 kB out of main bundle)
const lazyPusherLink = new ApolloLink((operation) => new Observable((observer) => {
  // Don't initialize Pusher (and don't hit the auth endpoint) when unauthenticated
  if (!Cookies.get('token')) {
    observer.complete();
    return () => {};
  }

  let cancelled = false;
  let innerSub = null;

  import('~/graphql/apolloPusherLink')
    .then(({ default: pusherLink }) => {
      if (cancelled) return;
      const sub = pusherLink.request(operation);
      if (sub) {
        innerSub = sub.subscribe(observer);
      } else {
        observer.complete();
      }
    })
    .catch((err) => observer.error(err));

  return () => {
    cancelled = true;
    innerSub?.unsubscribe();
  };
}));

export default lazyPusherLink;
